<template>
  <div class="home-cooperate">
    <div class="container">
      <div>
        <div class="home-cooperate-title">{{ $t("home.cooperate") }}</div>
    <!--    <div class="home-cooperate-more">更多</div>-->
      </div>
      <div class="home-cooperate-line"></div>

      <div class="home-cooperate-list">
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_1.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_2.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_3.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_4.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_5.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_6.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_7.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_8.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_9.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_10.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_11.png"></div>
        <div class="home-cooperate-img-div"><img class="home-cooperate-img" src="../../assets/home/cooperate_12.png"></div>
      </div>

    </div>
  </div>

</template>

<script>

export default {
  name: 'HelloWorld',
  props: {

  },
  components: {

  },
  data() {
    return {
      newsList:'http://localhost/PWmat-server/cms/public/api/articles?page=1&pagesize=4',
      news:'http://localhost/PWmat-server/cms/public/api/pages/1'
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .home-cooperate{
    margin-top: 90px;
  }
  .home-cooperate-title{
    display: inline-block;
    font-size:32px;
    font-family:PingFangSC-Regular,sans-serif;
    font-weight:400;
    color:rgba(73,145,201,1);
    line-height:45px;
  }
  .home-cooperate-more{
    display: inline-block;
    float: right;
    margin-top: 12px;
    font-size:24px;
    font-family:PingFangSC-Light,sans-serif;
    font-weight:300;
    color:rgba(79,76,77,1);
    line-height:33px;
  }
  .home-cooperate-line{
    margin-top: 8px;
    height:1px;
    background:rgba(240,240,240,1);
  }
  .home-cooperate-list{
    margin-top: 10px;
    margin-left: -15px;
    margin-right: -15px;
    margin-bottom: 60px;
  }
  .home-cooperate-img-div{
    width: 255px;
    height: 90px;
    margin: 30px 15px 0px 15px;
    padding: 15px 0;
    display: inline-block;
    text-align: center;
  }
  .home-cooperate-img{
    max-width: 220px;
    max-height: 60px;
  }

</style>
